<template lang="pug">
    a(href="https://wa.me/5511949745230", target="_blank")#whatsapp
        img(:src="require('@images/whatsHeader.png')")
</template>

<script>
export default {
    name: "component-whatsapp",
}
</script>

<style lang="stylus" scoped src="./Whatsapp.styl"></style>